import { getOnboardingStatus, enableOnboarding } from 'Services/onboardingManager'
import { openModal } from 'Services/vueModal'
import { parse as parseQuery } from 'qs'
import { parse as parseUrl } from 'url'
import onboardingTypes from 'Enums/onboardingTypes'
import jsonWebToken from 'Services/jsonWebToken'

export default {
  mounted: function () {

    const isAuthorized = jsonWebToken.token !== ''
    const { newUser, newCompany, migrationUser, migrationCompany } = onboardingTypes
    const { query } = parseUrl(location.href)
    const { onboardingMigration, onboardingWizard } = parseQuery(query)

    if (onboardingMigration) {
      enableOnboarding({ isCompany: onboardingMigration === 'company', isSnetUser: true })
    }

    if (onboardingWizard) {
      enableOnboarding({ isCompany: true, isSnetUser: false })
    }

    const status = getOnboardingStatus()
    const OnboardingComponent = {
      [newUser]: () => import('Components/QuoteRequest/Modal/modalOnboardingNewUser.vue'),
      [newCompany]: () => import('Components/QuoteNegotiation/Modal/modalOnboardingNewCompany.vue'),
      [migrationUser]: () => import('Components/QuoteRequest/Modal/modalOnboardingMigratedUser.vue'),
      [migrationCompany]: () => import('Components/QuoteNegotiation/Modal/modalOnboardingMigratedCompany.vue'),
    }[status] || null

    if (isAuthorized && OnboardingComponent) {
      const params = { maxWidth: 636 }

      openModal(this, OnboardingComponent, { params })
    }
  },
}